import { render } from "./Bikes.vue?vue&type=template&id=de18f456&scoped=true&ts=true"
import script from "./Bikes.vue?vue&type=script&lang=ts"
export * from "./Bikes.vue?vue&type=script&lang=ts"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./Bikes.vue?vue&type=style&index=1&id=de18f456&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de18f456"]])

export default __exports__